import { Navigate } from 'react-router-dom'; import { useAuth } from '../context/AuthContext'; export default function ProducerRoute({ children }) { const { 
  user, loading } = useAuth(); if (loading) {
    return <div className="text-center py-8">Loading...</div>;
  }
  return user && user.role === 'producer' ? children : <Navigate to="/" />;
}

